import ZkButtonGroup from './src/main.vue'
ZkButtonGroup.install = function (Vue) {
  Vue.component(ZkButtonGroup.name, ZkButtonGroup)
}

export default ZkButtonGroup



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/buttonGroup/index.js